import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { IPostUser, IPutUser } from "../interfaces/User";
import { IFormChangePassword, INewUser } from "../interfaces/User/newUser";

export const putUser = async (data: IPutUser) => {
  const response = await api.put(`/web/user`, {
    ...data,
  });
  return response;
};

export const postUser = async (data: IPostUser) => {
  const response = await api.post(`/auth/signup`, data);
  return response;
};

export const getUser = async () => {
  const { data } = await api.get<INewUser>(`/web/user`);
  return data;
};

export const useUser = (tokens: { enable: boolean }) => {
  const { enable } = tokens;
  return useQuery(["user"], getUser, {
    enabled: !!enable,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60,
  });
};

export const postChangePassword = async (data: IFormChangePassword) => {
  const { new_password, old_password } = data;
  const response = await api.post(`/auth/changepassword`, {
    new_password,
    old_password,
  });
  return response;
};
